const mutations = {
    SET_ERROR_ROLES(state, payload) {
        state.error = payload;
    }
};

export default mutations;
